import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MissionSection() {
  const { ref: containerRef, isVisible: containerVisible } = useScrollAnimation(0.1);

  return (
    <section id="mission" className="relative py-36 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bbf5207f49eb2eccb2f3a29882a1029c.jpg"
          alt="ミッション背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1C1410]/70 via-[#1C1410]/60 to-[#1C1410]/75" />
      </div>

      <div
        ref={containerRef}
        className={`relative z-10 max-w-2xl mx-auto text-center fade-in ${containerVisible ? 'visible' : ''}`}
      >
        <p className="text-[#E8C4C4]/80 text-xs tracking-[0.5em] mb-8 uppercase">Mission</p>

        <h2
          className="text-white text-3xl md:text-5xl font-light leading-[1.8] mb-10"
          style={{ fontFamily: 'Noto Serif JP, serif' }}
        >
          人の想いに寄り添い、<br />
          温もりのある社会をつくる。
        </h2>

        <div className="flex justify-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#E8C4C4]/40 mt-3" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#E8C4C4]/40 mt-2" />
          <div className="w-8 h-px bg-[#E8C4C4]/40 mt-3" />
        </div>

        <p className="text-white/70 text-sm md:text-base leading-[2.2] mb-10" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
          Hugは、「抱きしめる」という意味を持つ社名の通り、<br />
          人と人とのつながりを大切にする企業です。<br /><br />
          命に寄り添うサービスを通して、<br />
          家族の大切な想いに寄り添い続けます。
        </p>

        <p
          className="text-white/90 text-base md:text-lg font-light"
          style={{ fontFamily: 'Noto Serif JP, serif' }}
        >
          悲しみの中にも、<br />
          <em className="not-italic font-medium" style={{ color: '#F2D9D9' }}>ぬくもりを感じられるように。</em>
        </p>

        <div className="flex flex-wrap justify-center gap-3 mt-12">
          {['命', 'つながり', 'ぬくもり'].map((word) => (
            <span
              key={word}
              className="text-white/50 text-xs tracking-[0.4em] border border-white/20 px-5 py-2 rounded-full"
            >
              {word}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
